import { $qs, $qsa } from './utils/QuerySelector';
import gsap from 'gsap';

function dealHover() {


   
    const dealHovers = $qsa('[data-name="deal-hover"]');

    if (!dealHovers|| window.innerWidth < 1024) return;

    // return;

    

    [...dealHovers].forEach((dealHover) => {
       
        const left = $qsa('[data-name="deal-hover-left"]', dealHover);
        const right = $qsa('[data-name="deal-hover-right"]', dealHover);
        const logos = $qsa('[data-js="scale-logo"] img, [data-js="scale-logo-text"]', dealHover);
        const locations = $qsa('[data-js="location"]', dealHover);
        const bg = $qsa('[data-name="deal-hover-bg"]', dealHover);
        const svgs = $qsa('.fill-white', dealHover);

        dealHover.addEventListener('mouseenter', (e) => {
            // const cursor = e.target.parentNode.querySelector('.cursor-content');
            console.info('mouseenter');
            // if(!dealHover.classList.contains('open')){
            let tl = new gsap.timeline();   
            tl

            // .to( left, { x: '30px' }, 'start')
            // .to( right, { x: '-30px' }, 'start')
            .to(logos, {scale: 0.5, transformOrigin: 'top center'}, 'start')
            .to( locations, { opacity: '1' }, 'start')
            .to( bg, { opacity: '1' }, 'start')
            // .to( dealHover, { color: '#2658A6' }, 'start')
            // .to( svgs, { fill: '#2658A6' }, 'start')

            // .to( dealHover, { height: '250px' }, 'start')
            .add(() => { dealHover.classList.add('open')})
            // .add(() => { dealHover.classList.remove('closed')})

            // }

        });
        dealHover.addEventListener('mouseout', (e) => {
            // const cursor = e.target.parentNode.querySelector('.cursor-content');
            // let tl = new gsap.timeline({defaults :{ duration: 0.3}});  
            console.info('mouseleave');
            // if(dealHover.classList.contains('open')){

            let tl = new gsap.timeline();   
            tl
            // .add(() => { dealHover.classList.add('closed')})
            // .to( left, { x: '0'}, 'start')
            .to( right, { x: '0' }, 'start')
            .to(logos, {scale: 1, transformOrigin: 'top center'}, 'start')
            .to( locations, { opacity: '0' }, 'start')

            .to( bg, { opacity: '0' }, 'start')
            // .to( dealHover, { color: '#fff' }, 'start')
            // .to( svgs, { fill: '#fff' }, 'start')
            // .to( dealHover, { height: 'auto' }, 'start')
            .add(() => { dealHover.classList.remove('open')})
            // }

        });
        


    });


    const filterToggle = $qs('[data-name="open-deal-filters"]');
    const filterClose = $qs('[data-name="close-deal-filters"]');
    const filters = $qsa('[data-name="deal-filters"]');

    if (!filterToggle) return;

    filterToggle.addEventListener('click', function(){
        if(filterToggle.classList.contains('filter-open')){
            filterToggle.classList.remove('filter-open');
            gsap.to(filters, {autoAlpha: 0});
            gsap.to(filterClose, {autoAlpha: 0});
            gsap.to(filterToggle, {color: '#fff'});
        }else{
        filterToggle.classList.add('filter-open');
        gsap.to(filters, {autoAlpha: 1});
        gsap.to(filterClose, {autoAlpha: 1});
        gsap.to(filterToggle, {color: '#081223'});
        }
    });


}


export default dealHover;